import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RulesConfigComponent } from 'src/app/core/components/rules-config/rules-config.component';
import { ValidityModel } from 'src/app/core/models/merchandizing-config';
import { CalendarValidityReferenceModel, ConditionReferenceModel, DateTimeDimensionReferenceModel } from 'src/app/core/models/reference-model/reference-general-model';

@Component({
    selector: 'op-ancillary-service-validity',
    templateUrl: './validity.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValidityComponent {
    private _jsonURL = 'assets/data/merchandizing/attributes&rules_config.json';

    @Input() calendarValidityReferences$ = new BehaviorSubject<CalendarValidityReferenceModel[]>(null);
    @Input() dateTimeDimensionReferences$ = new BehaviorSubject<DateTimeDimensionReferenceModel[]>(null);
    @Input() conditionReferences$ = new BehaviorSubject<ConditionReferenceModel[]>(null);

    @ViewChild(RulesConfigComponent) ruleComponent: RulesConfigComponent;

    @Input() validityConfig: ValidityModel;
    public focusing: boolean = false;
    constructor(private changeDetectorRef: ChangeDetectorRef, 
        private http: HttpClient) {
        this.getJSON().subscribe(data => {
            this.validityConfig = this.removeLocalTimezone(data.validity);
            this.changeDetectorRef.detectChanges();
        });
    }

    private getJSON(): Observable<any> {
        return this.http.get(this._jsonURL);
    }

    get controlLength(): number {
        if (this.ruleComponent) {
            return this.ruleComponent.forms.controls.length;
        }
        return 0;
    }

    public add() {
        this.ruleComponent.add();
    }

    public detectChanges() {
        this.changeDetectorRef.detectChanges();
    }

    private removeLocalTimezone(validityData) {
        validityData?.types[0].dateType?.forEach(dateType => {
            dateType.calendarType?.forEach(type => {
                if (type.timeZone) {
                    let localIndex = type.timeZone.findIndex(item => item.timeZoneCode == 'utc');
                    type.timeZone.splice(localIndex, 1);
                }
            })
        })
        return validityData;
    }

}
